<template>
    <div class="header-container">
        <img id="fit-header-img" alt="Vue logo" src="../assets/Header01.jpg">
        <img id="fit-header-img-mobile" alt="Vue logo" src="../assets/Header01mobile.jpg">
    </div>
</template>

<style>
    .header-container {
        width: 100%;
    }
    #fit-header-img {
        width: 100%;
        display: flex;
    }
    #fit-header-img-mobile {
        width: 100%;
        display: none;
    }
    @media only screen and (max-width: 768px) {
        #fit-header-img {
            display: none;
        }
        #fit-header-img-mobile {
            display: flex;
        }
    }
</style>